import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedDate, FormattedTime } from "react-intl";
import styled from "styled-components/macro";

import Gallery from "../../../components/Gallery";
import {
  PageContent,
  CardContainer,
  RichText,
  Heading1,
  Row,
  Col,
  Hidden,
  Paragraph,
} from "../../../components/";
import Post from "../Post";
import Links from "../Links";
import Details from "../Details";
import { DEFAULT_TIMEZONE } from "../../../utils/calc";

const Content = styled.article`
  min-height: 85vh;
`;

const Empty = styled.p`
  padding: 3rem 2rem 4rem;
  overflow: hidden;
  &:after {
    content: "";
    padding-top: 66.6%;
    float: left;
  }
`;

const BlogContent = styled.div`
  max-width: 1024px;
`;

const Card = ({ currentPost, provider, posts }) => (
  <PageContent transparent>
    <CardContainer seemless={currentPost && currentPost.image}>
      {currentPost ? (
        <Content>
          <Row>
            <Col size="md" count={8}>
              {currentPost.image && <Gallery images={[currentPost.image]} />}
              <BlogContent>
                <Heading1>{currentPost.title}</Heading1>
                <Hidden size="md,lg">
                  <Paragraph>
                    <span>
                      <FormattedMessage
                        id="pages.Blog.postSub"
                        values={{ user: currentPost.author.fullName }}
                      />
                    </span>
                    <br />
                    <small>
                      <FormattedDate
                        month="long"
                        day="2-digit"
                        value={Date.parse(currentPost.publishedAt)}
                      />
                      {", "}
                      <FormattedTime
                        value={Date.parse(currentPost.publishedAt)}
                        timeZone={DEFAULT_TIMEZONE}
                      />
                      {", "}
                      {currentPost.readingTime > 0 ? (
                        <FormattedMessage
                          id="pages.Blog.readingTime.aprox"
                          values={{ readingTime: currentPost.readingTime }}
                        />
                      ) : (
                        <FormattedMessage id="pages.Blog.readingTime.lessThenMinute" />
                      )}
                    </small>
                  </Paragraph>
                </Hidden>
                <RichText text={currentPost.content} />
              </BlogContent>
              <Links posts={posts} currentPost={currentPost} provider={provider} />
            </Col>
            <Col size="md" count={4}>
              <Details posts={posts} currentPost={currentPost} provider={provider} />
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          {posts.map(post => (
            <Post key={post.id} post={post} provider={provider} />
          ))}
        </Content>
      )}
      {posts.length < 1 && (
        <Empty>
          <FormattedMessage id="pages.Blog.empty" />
        </Empty>
      )}
    </CardContainer>
  </PageContent>
);

Card.propTypes = {
  provider: PropTypes.object.isRequired,
  posts: PropTypes.array,
  currentPost: PropTypes.object,
};

Card.defaultProps = {
  posts: [],
  currentPost: null,
};

export default Card;
